module.exports = __webpack_public_path__ + "img/logo-pc2capital.ab501025.png";